import HorizontalSwipe from './horizontal-swipe';
import './horizontal-swipe.scss';

export default HorizontalSwipe;
